const React = require('react');
const Loading = require('../Loading');


module.exports = React.forwardRef(({
  loading,
  children,
  inner,
  helperText,
  ...props
}, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={'rlv ' + (props.className || '')}
    >
      <div
        {...inner}
        className={'ftBlur4.loading dn hmin40 '
          + (loading ? 'loading ' : '')
          + (inner && inner.className || '')
        }
      >{children || null}</div>
      {loading ? (<Loading>{helperText || null}</Loading>) : null}
    </div>
  );
});
